import { auth } from '../../utils/auth';
import { BoxProps } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { redirectToSignUp } from '../../utils/router';
import { useLocation } from 'react-router-dom';
import {
  Root,
  Content,
  Link,
  Separator,
  SeparatorLine,
  ContentWrapper,
} from './AuthenticationLinksStyle';

interface Props extends BoxProps {
  useContainer?: boolean;
  showSignInLink?: boolean;
  showSignUpLink?: boolean;
}

function AuthenticationLinks({ useContainer, showSignInLink, showSignUpLink, ...rest }: Props) {
  const location = useLocation();

  const handleSignin = () => {
    auth.login();
  };

  const handleSignup = () => {
    redirectToSignUp(location.pathname);
  };
  return (
    <Root useContainer={useContainer} {...rest}>
      {showSignInLink && (
        <ContentWrapper>
          <Content>
            <FormattedMessage id='authenticationLinks.signInContent' />
          </Content>
          <Link onClick={handleSignin}>
            <FormattedMessage id='authenticationLinks.signInLink' />
          </Link>
        </ContentWrapper>
      )}

      {showSignInLink && showSignUpLink && (
        <Separator>
          <SeparatorLine />
        </Separator>
      )}

      {showSignUpLink && (
        <ContentWrapper>
          <Content>
            <FormattedMessage id='authenticationLinks.signUpContent' />
          </Content>
          <Link onClick={handleSignup}>
            <FormattedMessage id='authenticationLinks.signUpLink' />
          </Link>
        </ContentWrapper>
      )}
    </Root>
  );
}

export default AuthenticationLinks;
